import { resetAuthExpiryHandling } from '@glyphic/shared-core'

import { logoutRequest } from '../api/auth'
import { clearSession } from './session'

/** 请求服务端登出并清理本地会话与缓存，然后重定向到登录页 */
export async function performLogout(): Promise<void> {
  try {
    await logoutRequest()
  } catch {
    /* 网络失败仍清理本地，避免卡在半登出 */
  } finally {
    logoutAndClearLocal()
    // 重定向到登录页
    window.location.href = '/login'
  }
}

const LOCAL_SUFFIXES = [
  'profile-name',
  'settings-api-base',
  'default-model',
  'user-public-id',
  'prompt-templates',
  'create-session',
  'nav-modules',
] as const

import { clearUserAuthorization } from './userAuthorization'

/** 登出：清理本地偏好与会话（仅存 glyphicai- 前缀键） */
export function logoutAndClearLocal(): void {
  resetAuthExpiryHandling()
  clearSession()
  clearUserAuthorization()
  try {
    for (const suf of LOCAL_SUFFIXES) {
      localStorage.removeItem(`glyphicai-${suf}`)
    }
    sessionStorage.removeItem('glyphicai-active-model')
  } catch {
    /* ignore */
  }
}
